import { render } from "./AlzataButton.vue?vue&type=template&id=6f40ad75"
import script from "./AlzataButton.vue?vue&type=script&lang=js"
export * from "./AlzataButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__